import React from 'react'
import { Bar } from 'react-chartjs-2'
// import ChartDataLabels from 'chartjs-plugin-datalabels';


const PerKwChart = ({ 
  viewOptions, 
  years, 
  totalUsage, 
  totalProduction, 
  loan1Bills, 
  loan2Bills,
  escalationRateA,
  escalationRateB,
  loanTermA,
  loanTermB, 
  ppaRateA, 
  ppaRateB, 
  width, 
  smallBreakPoint }) => {



  const total = (arr) => arr.reduce((a, b) => a + b)

  // let data

/**
 * 0.115 * 0.0299 
 * @param {*} escalationRate 
 * @param {*} ppaRate 
 * @param {*} loanTerm 
 */

  const calculateAvgPpaCost = (escalationRate, ppaRate, loanTerm) => {
    let totalSolarCost = 0;
    let curSolarCost = ppaRate;
    for (let i = 0; i < loanTerm; i++) {
      curSolarCost += i === 0 ? 0 : curSolarCost * escalationRate;
      totalSolarCost += curSolarCost;
    }
    return (totalSolarCost / loanTerm).toFixed(3);
  }

  calculateAvgPpaCost(escalationRateA, ppaRateA, loanTermA);

  let data = [
    {
      categoryPercentage: .90,
      barPercentage: 1.0,
      barThickness: width > smallBreakPoint ? 120 : 80,
      label: '25 Year Average $',
      datalabels: {
        display: false
      },
      data: [
        (((total(years) * 12) / 25) / totalUsage).toFixed(3),
        ppaRateA ? calculateAvgPpaCost(escalationRateA, ppaRateA, loanTermA) : (((total(loan1Bills) * 12) / 25) / totalProduction).toFixed(3),
        ppaRateB ? calculateAvgPpaCost(escalationRateB, ppaRateB, loanTermB) : (((total(loan2Bills) * 12) / 25) / totalProduction).toFixed(3),
      ],
      backgroundColor: [
        'rgb(249,58,58,1)',
        'rgb(65,126,238,1)',
        'rgb(139,176,244,1)',
      ]
    }
  ]

  let oneOptionsData = [
    {
      categoryPercentage: .90,
      barPercentage: 1.0,
      barThickness: 120,
      label: '25 Year Average $',
      datalabels: {
        display: false
      },
      data: [
        (((total(years) * 12) / 25) / totalUsage).toFixed(3),
        ppaRateA ? ppaRateA : (((total(loan1Bills) * 12) / 25) / totalProduction).toFixed(3),
      ],
      backgroundColor: [
        'rgb(249,58,58,1)',
        'rgb(65,126,238,1)'
      ]
    }
  ]

  let oneOption = {
    tooltips: {
      bodyFontFamily: 'Lexend',
      bodyFontStyle: '300',
      shadow: '0px 0px 8px 2px rgba(0,0,0,0.12)',
      titleFontSize: false,
      bodyFontSize: 20,
      displayColors: false,
      backgroundColor: 'rgba(246,246,246,1)',
      footerFontColor: 'rgba(248,47,43,1)',
      hoverRadius: 6,
      callbacks: {
        title: function () { },
        label: function (context) {
          // console.log(context)
          return '$' + context.value
        },
        labelTextColor: function (context) {
          if (context.index === 0) {
            return 'rgba(248,47,43,1)'
          }
          if (context.index === 1) {
            return 'rgb(65,126,238,1)'
          }
        },
      },
    },
    title: {
      display: true,
      text: '',
      fontSize: 25,
      fontColor: '#000'
    },
    legend: {
      display: false,
      position: 'bottom',
      labels: { fontColor: '#000' }
    }, scales: {
      xAxes: [{
        ticks: {
          fontFamily: 'Lexend',
          fontSize: width > smallBreakPoint ? 18 : 10,
          fontStyle: '200',
          padding: 10,
          // display: false
        },
        gridLines: {
          color: "rgba(0, 0, 0, 0)",
          drawBorder: false,
          zeroLineColor: 'transparent',
        }
      }],
      yAxes: [{
        categoryPercentage: 1.5,
        barPercentage: 1.0,
        ticks: {
          fontFamily: 'Lexend',
          fontSize: width > smallBreakPoint ? 20 : 10,
          fontStyle: '200',
          padding: 10,
          beginAtZero: true,
          callback: function (value) {
            return value.toLocaleString(undefined, { style: "currency", currency: "USD" })
          }
        },
        gridLines: {
          borderDash: [7, 6],
          color: 'rgba(209, 209, 209, 1)',
          drawBorder: false,
          // zeroLineColor: 'transparent',
        }
      }]
    }
  }

  let options = {
    tooltips: {
      bodyFontFamily: 'Lexend',
      bodyFontStyle: '300',
      shadow: '0px 0px 8px 2px rgba(0,0,0,0.12)',
      titleFontSize: false,
      bodyFontSize: 20,
      displayColors: false,
      backgroundColor: 'rgba(246,246,246,1)',
      footerFontColor: 'rgba(248,47,43,1)',
      hoverRadius: 6,
      callbacks: {
        title: function () { },
        label: function (context) {
          // console.log(context)
          return '$' + context.value
        },
        labelTextColor: function (context) {
          if (context.index === 0) {
            return 'rgba(248,47,43,1)'
          }
          if (context.index === 1) {
            return 'rgb(65,126,238,1)'
          }
          if (context.index === 2) {
            return 'rgb(139,176,244,1)'
          }
        },
      },
    },
    title: {
      display: true,
      text: '',
      fontSize: 25,
      fontColor: '#000'
    },
    legend: {
      display: false,
      position: 'bottom',
      labels: { fontColor: '#000' }
    }, scales: {
      xAxes: [{
        ticks: {
          fontFamily: 'Lexend',
          fontSize: width > smallBreakPoint ? 18 : 10,
          fontStyle: '200',
          padding: 10,
          // display: false
        },
        gridLines: {
          color: "rgba(0, 0, 0, 0)",
          drawBorder: false,
          zeroLineColor: 'transparent',
        }
      }],
      yAxes: [{
        categoryPercentage: 1.5,
        barPercentage: 1.0,
        ticks: {
          fontFamily: 'Lexend',
          fontSize: width > smallBreakPoint ? 20 : 10,
          fontStyle: '200',
          padding: 10,
          beginAtZero: true,
          callback: function (value) {
            return value.toLocaleString(undefined, { style: "currency", currency: "USD" })
          }
        },
        gridLines: {
          borderDash: [7, 6],
          color: 'rgba(209, 209, 209, 1)',
          drawBorder: false,
          // zeroLineColor: 'transparent',
        }
      }]
    }
  }


  let labels = ['Utility Power', 'Solar Option 1', 'Solar Option 2']

  let oneLabel = ['Utility Power', 'Solar Power']


  if (viewOptions === 1) {
    data = oneOptionsData
    options = oneOption
    labels = oneLabel
  }




  return (
    <div>
      <Bar
        data={{
          labels: labels,
          datasets: data
        }}
        options={options} 
        height={width > 576 ? 160 : 225}
        width={307}
      />
    </div>
  )

}




export default PerKwChart